import React, { useEffect, useState, useRef } from "react";
import "./dropdown.css"
import { FaChevronDown } from "react-icons/fa";


// export const EmpDropdown = ({ placeholder, data, handleChange, DataChange = () => { } // Optional parameter with default no-op function
// }) => {
//   const [searchTerm, setSearchTerm] = useState("");
//   const [user, setuser] = useState(JSON.parse(localStorage.getItem('token')))
//   const [filteredItems, setFilteredItems] = useState(data || []);
//   const [isDropdownOpen, setDropdownOpen] = useState(false);

//   const handleSearch = (value) => {
//     setSearchTerm(value);
//     setFilteredItems(
//       data.filter(item =>
//         item.name.toLowerCase().includes(value.toLowerCase())
//       )
//     );
//   };

//   const handleSelect = (emp_id, name) => {
//     setSearchTerm(name);
//     setDropdownOpen(false);
//     handleChange(emp_id);
//   };

//   return (
//     <div className="searchable-dd">
//       <input
//         type="text"
//         className="dd-input"
//         placeholder={placeholder || "Search employee..."}
//         value={searchTerm}
//         onFocus={() => setDropdownOpen(true)}
//         onBlur={() => setTimeout(() => setDropdownOpen(false), 200)}
//         onChange={(e) => handleSearch(e.target.value)}
//       />
//       {isDropdownOpen && (
//         <div className="dd-menu">
//           {user.type == 1 && filteredItems.length > 0 ? (
//             filteredItems.map((item) => (
//               <div
//                 key={item.emp_id}
//                 className="dd-item"
//                 onClick={() => { handleSelect(item.emp_id, item.name); DataChange(item) }}
//               >
//                 {item.name}
//               </div>
//             ))
//           ) : (
//             <div className="dd-no-results">No results found</div>
//           )}
//         </div>
//       )}
//     </div>
//   );
// };


export const EmpDropdown = ({
  placeholder,
  data,
  handleChange,
  DataChange = () => { },
  selectedId, // Pass the current active emp_id here
}) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredItems, setFilteredItems] = useState([]);
  const [isDropdownOpen, setDropdownOpen] = useState(false);

  // Sync searchTerm with the placeholder (UserName) when it changes
  useEffect(() => {
    setSearchTerm(placeholder || "");
    setFilteredItems(data || []);
  }, [placeholder, data]);

  const handleSearch = (value) => {
    setSearchTerm(value);
    if (value.trim() === "") {
      setFilteredItems(data);
    } else {
      setFilteredItems(
        data.filter((item) =>
          item.name?.toLowerCase().includes(value.toLowerCase()) ||
          item.emp_id?.toString().toLowerCase().includes(value.toLowerCase()) ||
          item.email?.toLowerCase().includes(value.toLowerCase())
        )
      );
    }
  };

  const handleFocus = () => {
    setDropdownOpen(true);
    setFilteredItems(data);
  };

  const handleSelect = (item) => {
    setSearchTerm(item.name);
    setDropdownOpen(false);
    handleChange(item.emp_id); // Updates parent state
    DataChange(item);         // Fetches schedule
  };

  return (
    <div className="searchable-dd" style={{ position: 'relative' }}>
      <div className="dd-input-wrapper" style={{ position: 'relative' }}>
        <input
          type="text"
          className="dd-input form-control"
          placeholder="Search employee..."
          value={searchTerm}
          onFocus={handleFocus}
          onBlur={() => setTimeout(() => setDropdownOpen(false), 200)}
          onChange={(e) => handleSearch(e.target.value)}
        />
        <FaChevronDown
          className={`dd-arrow ${isDropdownOpen ? "open" : ""}`}
          style={{ position: 'absolute', right: '10px', top: '10px' }}
        />
      </div>

      {isDropdownOpen && (
        <div className="dd-menu" style={{
          position: 'absolute', zIndex: 1000, background: '#fff', width: '100%', border: '1px solid #ccc'
        }}>
          {filteredItems.length > 0 ? (
            filteredItems.map((item) => (
              <div
                key={item.emp_id}
                className={`dd-item ${item.emp_id === selectedId ? "active-item" : ""}`}
                style={{
                  padding: '8px',
                  cursor: 'pointer',
                  backgroundColor: item.emp_id === selectedId ? '#f0f0f0' : 'transparent',
                  display: 'flex',
                  justifyContent: 'space-between'
                }}
                onMouseDown={() => handleSelect(item)} // Fires before Blur
              >
                <span>{item.name}</span>

                {/* ✅ Tick Mark for selected item */}
                {item.emp_id === selectedId && (
                  <span className="text-primary">✔</span>
                )}
              </div>
            ))
          ) : (
            <div className="dd-no-results" style={{ padding: '8px' }}>No employee found</div>
          )}
        </div>
      )}
    </div>
  );
};

// export const EmpDropdowndash = ({ placeholder, data, handleChange }) => {
//     const [searchTerm, setSearchTerm] = useState("");
//     const [filteredItems, setFilteredItems] = useState(data || []);
//     const [isDropdownOpen, setDropdownOpen] = useState(false);

//     useEffect(() => {
//         setSearchTerm(placeholder)
//     }, [placeholder]);

//     const handleSearch = (value) => {
//         setSearchTerm(value);
//         setFilteredItems(
//             data.filter(item =>
//                 item.name.toLowerCase().includes(value.toLowerCase())
//             )
//         );
//     };

//     const handleSelect = (emp_id, name) => {
//         setSearchTerm(name);
//         setDropdownOpen(false);
//         handleChange(emp_id);
//     };

//     return (
//         <div className="searchable-dd">
//             <input
//                 type="text"
//                 className="dd-input"
//                 placeholder={"Search employee..."}
//                 value={searchTerm}
//                 onFocus={() => setDropdownOpen(true)}
//                 onBlur={() => setTimeout(() => setDropdownOpen(false), 200)}
//                 onChange={(e) => handleSearch(e.target.value)}
//             />
//             {isDropdownOpen && (
//                 <div className="dd-menu">
//                     {filteredItems.length > 0 ? (
//                         filteredItems.map((item) => (
//                             <div
//                                 key={item.emp_id}
//                                 className="dd-item"
//                                 onClick={() => handleSelect(item.emp_id, item.name)}
//                             >
//                                 {item.name}
//                             </div>
//                         ))
//                     ) : (
//                         <div className="dd-no-results">Type to Search</div>
//                     )}
//                 </div>
//             )}
//         </div>
//     );
// };

export const EmpDropdowndash = ({
  placeholder,
  data,
  handleChange,
  selectedId, // ✅ Add selected employee id
}) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredItems, setFilteredItems] = useState([]);
  const [isDropdownOpen, setDropdownOpen] = useState(false);

  // ✅ Set input value but keep full list ready
  useEffect(() => {
    setSearchTerm(placeholder || "");
    setFilteredItems(data || []);
  }, [placeholder, data]);

  // ✅ Search handler
  const handleSearch = (value) => {
    setSearchTerm(value);

    if (value.trim() === "") {
      setFilteredItems(data);
    } else {
      setFilteredItems(
        data.filter((item) =>
          item.name?.toLowerCase().includes(value.toLowerCase()) ||
          item.emp_id?.toString().toLowerCase().includes(value.toLowerCase()) ||
          item.email?.toLowerCase().includes(value.toLowerCase())
        )
      );
    }
  };

  // ✅ When user clicks input → show full list
  const handleFocus = () => {
    setDropdownOpen(true);
    setFilteredItems(data);
  };

  const handleSelect = (emp_id, name) => {
    setSearchTerm(name);
    setDropdownOpen(false);
    handleChange(emp_id);
  };

  // ✅ Close dropdown when clicking outside
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="searchable-dd" ref={dropdownRef}>
      <div className="dd-input-wrapper">
        <input
          type="text"
          className="dd-input"
          placeholder="Search employee..."
          value={searchTerm}
          onFocus={handleFocus}
          onChange={(e) => handleSearch(e.target.value)}
        />
        <FaChevronDown
          className={`dd-arrow ${isDropdownOpen ? "open" : ""}`}
        />      </div>

      {isDropdownOpen && (
        <div className="dd-menu">
          {filteredItems.length > 0 ? (
            filteredItems.map((item) => (
              <div
                key={item.emp_id}
                className={`dd-item ${item.emp_id === selectedId ? "active-item" : ""
                  }`}
                onMouseDown={() =>
                  handleSelect(item.emp_id, item.name)
                }
              >
                {item.name}

                {/* ✅ Optional Tick Mark */}
                {item.emp_id === selectedId && (
                  <span style={{ float: "right" }}>✔</span>
                )}
              </div>
            ))
          ) : (
            <div className="dd-no-results">No employee found</div>
          )}
        </div>
      )}
    </div>
  );
};



export const DeptDropdown = ({ placeholder, data, handleChange }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredItems, setFilteredItems] = useState(data || []);
  const [isDropdownOpen, setDropdownOpen] = useState(false);

  // useEffect(() => {
  //     console.log(data);
  // }, []);
  const handleSearch = (value) => {
    setSearchTerm(value);
    setFilteredItems(
      data.filter(item =>
        item.title.toLowerCase().includes(value.toLowerCase())
      )
    );
    console.log(value);
  };

  const handleSelect = (id, title) => {
    setSearchTerm(title);
    setDropdownOpen(false);
    handleChange(id);
  };

  return (
    <div className="searchable-dd">
      <input
        type="text"
        className="dd-input"
        placeholder={placeholder || "Search Department..."}
        value={searchTerm}
        onFocus={() => setDropdownOpen(true)}
        onBlur={() => setTimeout(() => setDropdownOpen(false), 200)}
        onChange={(e) => handleSearch(e.target.value)}
      />
      {isDropdownOpen && (
        <div className="dd-menu">
          {filteredItems.length > 0 ? (
            filteredItems.map((item) => (
              <div
                key={item.id}
                className="dd-item"
                onClick={() => handleSelect(item.id, item.title)}
              >
                {item.title}
              </div>
            ))
          ) : (
            <div className="dd-no-results">No results found</div>
          )}
        </div>
      )}
    </div>
  );
};
export const SubDeptDropdown = ({ placeholder, data, handleChange }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredItems, setFilteredItems] = useState(data || []);
  const [isDropdownOpen, setDropdownOpen] = useState(false);

  const handleSearch = (value) => {
    setSearchTerm(value);
    setFilteredItems(
      data.filter(item =>
        item.SubDepartmentTitle.toLowerCase().includes(value.toLowerCase())
      )
    );
    console.log(value);
  };

  const handleSelect = (id, title) => {
    setSearchTerm(title);
    setDropdownOpen(false);
    handleChange(id);
  };

  return (
    <div className="searchable-dd">
      <input
        type="text"
        className="dd-input"
        placeholder={placeholder || "Search Department..."}
        value={searchTerm}
        onFocus={() => setDropdownOpen(true)}
        onBlur={() => setTimeout(() => setDropdownOpen(false), 200)}
        onChange={(e) => handleSearch(e.target.value)}
      />
      {isDropdownOpen && (
        <div className="dd-menu">
          {filteredItems.length > 0 ? (
            filteredItems.map((item) => (
              <div
                key={item.SubDepartmentId}
                className="dd-item"
                onClick={() => handleSelect(item.SubDepartmentId, item.SubDepartmentTitle)}
              >
                {item.SubDepartmentTitle}
              </div>
            ))
          ) : (
            <div className="dd-no-results">No results found</div>
          )}
        </div>
      )}
    </div>
  );
};



/**
 * EmployeeSearchSelect
 * Multi-select dropdown with search by name, email, or employee code.
 */
export const EmployeeSearchSelect = ({
  options = [],
  selectedValues = [],
  onChange,
  placeholder = "Select Employee",
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const containerRef = useRef(null);

  useEffect(() => {
    const handleOutside = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleOutside);
    return () => document.removeEventListener("mousedown", handleOutside);
  }, []);

  const q = searchTerm.toLowerCase().trim();
  const filtered = q
    ? options.filter((emp) => {
      const name = String(emp.name || "").toLowerCase();
      const email = String(emp.email || emp.emp_email || "").toLowerCase();
      const code = String(emp.EmployeeCode || emp.employee_code || emp.emp_code || emp.emp_id || "").toLowerCase();
      return name.includes(q) || email.includes(q) || code.includes(q);
    })
    : options;

  const selectedIds = selectedValues.map(String);
  const selectedLabels = options
    .filter((emp) => selectedIds.includes(String(emp.id)))
    .map((emp) => emp.name);

  return (
    <div ref={containerRef} style={{ position: "relative", width: "100%" }}>
      <div
        className="form-control d-flex align-items-center gap-1 flex-wrap"
        style={{ cursor: "pointer", minHeight: "42px", userSelect: "none" }}
        onClick={() => { setIsOpen((prev) => !prev); setSearchTerm(""); }}
      >
        {selectedLabels.length > 0 ? (
          selectedLabels.map((name, i) => (
            <span key={i} className="badge bg-primary" style={{ fontSize: "0.75rem", padding: "4px 8px" }}>
              {name}
            </span>
          ))
        ) : (
          <span className="text-muted">{placeholder}</span>
        )}
        <FaChevronDown
          style={{
            marginLeft: "auto",
            fontSize: "12px",
            transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
            transition: "transform 0.2s",
            flexShrink: 0,
          }}
        />
      </div>

      {isOpen && (
        <div
          style={{
            position: "absolute",
            top: "calc(100% + 4px)",
            left: 0,
            right: 0,
            zIndex: 9999,
            background: "#fff",
            border: "1px solid #dee2e6",
            borderRadius: "6px",
            boxShadow: "0 4px 16px rgba(0,0,0,0.12)",
            maxHeight: "300px",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <div style={{ padding: "8px", borderBottom: "1px solid #dee2e6", flexShrink: 0 }}>
            <input
              autoFocus
              type="text"
              className="form-control form-control-sm"
              placeholder="Search by name, email or code..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              onClick={(e) => e.stopPropagation()}
            />
          </div>
          <div style={{ overflowY: "auto", flexGrow: 1 }}>
            {filtered.length > 0 ? (
              filtered.map((emp) => {
                const isSelected = selectedIds.includes(String(emp.id));
                const code = emp.EmployeeCode || emp.employee_code || emp.emp_code || emp.emp_id || "";
                const email = emp.email || emp.emp_email || "";
                return (
                  <div
                    key={emp.id}
                    onMouseDown={(e) => { e.preventDefault(); onChange(emp.id); }}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                      padding: "8px 12px",
                      cursor: "pointer",
                      backgroundColor: isSelected ? "#e8f4ff" : "transparent",
                      borderBottom: "1px solid #f1f1f1",
                    }}
                    onMouseEnter={(e) => { if (!isSelected) e.currentTarget.style.background = "#f8f9fa"; }}
                    onMouseLeave={(e) => { e.currentTarget.style.background = isSelected ? "#e8f4ff" : "transparent"; }}
                  >
                    <input type="checkbox" readOnly checked={isSelected} style={{ accentColor: "#0d6efd", cursor: "pointer" }} />
                    <div style={{ flexGrow: 1 }}>
                      <div style={{ fontWeight: 500, fontSize: "0.875rem" }}>{emp.name}</div>
                      <div style={{ fontSize: "0.75rem", color: "#6c757d" }}>
                        {code && <span style={{ marginRight: "8px" }}>#{code}</span>}
                        {email && <span>{email}</span>}
                      </div>
                    </div>
                    {isSelected && <span style={{ color: "#0d6efd", fontSize: "14px" }}>✔</span>}
                  </div>
                );
              })
            ) : (
              <div style={{ padding: "16px", textAlign: "center", color: "#6c757d", fontSize: "0.875rem" }}>
                No employees found
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};